import React, { Component } from "react";
import {
  Card,
  CardBody,
  Row,
  Spin,
  Title,
  Copy,
  Wrapper
} from "app/NativeComponents/common";

class LeadUpdating extends Component {
  render() {
    if (
      this.props.active_property &&
      this.props.active_property.deal &&
      this.props.active_property.deal.removed != 1 &&
      this.props.active_property.deal.updating &&
      this.props.active_property.deal.updating.is_updating &&
      this.props.active_property.deal.updating.updating_type !==
        "skip_trace_leads_v2" &&
      this.props.active_property.deal.updating.updating_type !==
        "skip_trace_leads" &&
      this.props.active_property.deal.updating.updating_type !==
        "skip_trace_lead" &&
      this.props.active_property.deal.updating.updating_type !== "skip_trace"
    ) {
      return (
        <Card>
          <CardBody>
            <Row>
              <Spin size="small" />
              <Wrapper style={{ marginLeft: 10 }}>
                <Title>
                  {this.props.active_property.deal.updating.updating_title}
                </Title>
                <Copy>
                  {this.props.active_property.deal.updating.updating_text}
                </Copy>
              </Wrapper>
            </Row>
          </CardBody>
        </Card>
      );
    }
    return null;
  }
}

export default LeadUpdating;
